// extracted by mini-css-extract-plugin
export var content = "_ng-1";
export var fullScreen = "_ng-0";